<template>
    <div class="main-content">
        <div class="image-container">
            <img src="@/assets/maintenance/maintenance.svg" alt="maintenance image">
        </div>
        <div class="maintenance-title">{{ detail.title }}</div>
        <div class="maintenance-desc">{{ detail.desc }}</div>
    </div>
</template>

<script>
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
export default {
    name: "maintenance",
    data() {
        return {
            detail: {
                title: "",
                desc: ""
            }
        }
    },
    created() {
        this.getMaintenanceText();
    },
    methods: {
        getMaintenanceText() {
            return new Promise(resovle => {
                BzbsApi.apiNestleMaintenance().subscribe(
                    response => {
                        this.detail.title = response[0].line1
                        this.detail.desc = response[0].line2
                        resovle(response);
                    },
                    err => {
                        console.log(err);
                        resovle(err);
                    }
                )
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.main-content {
    height: 100vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    font-family: "DBHeaventRegular";
    .image-container {
        text-align: center;
        margin-bottom: 25px;
        img {
            width: 60vw;
        }
    }

    .maintenance-title {
        color: #65513e;
        font-size: 22px;
    }

    .maintenance-desc {
        color: #666666;
        font-size: 20px;
    }
}

</style>